import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductConfigurationComponent } from './product-configuration/product-configuration.component';
import { ProductIngredientsComponent } from './product-ingredients/product-ingredients.component';
import { ProductManufactureComponent } from './product-manufacture/product-manufacture.component';
import { ProductEOLComponent } from './product-eol/product-eol.component';
import { ProductUseComponent } from './product-use/product-use.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductChartAtGlanceComponent } from './product-chart-at-glance/product-chart-at-glance.component';
import { ProductReportGenerationComponent } from './product-report-generation/product-report-generation.component';
import { ProductDetailContentComponent } from './product-detail-content/product-detail-content.component';
import { UnsavedChangesGuard } from '@piqet-angular/shared';

const routes: Routes = [
  {
    path: 'setting',
    pathMatch: 'full',
    component: ProductDetailContentComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'configurations',
    pathMatch: 'full',
    component: ProductConfigurationComponent,
  },
  {
    path: 'product-ingredient',
    pathMatch: 'full',
    component: ProductIngredientsComponent,
  },
  {
    path: 'product-manufacture',
    pathMatch: 'full',
    component: ProductManufactureComponent,
  },
  {
    path: 'product-use',
    pathMatch: 'full',
    component: ProductUseComponent,
  },
  {
    path: 'prod-end-of-life',
    pathMatch: 'full',
    component: ProductEOLComponent,
  },
  {
    path: 'product-list',
    component: ProductListComponent,
  },
  {
    path: 'chart-at-glance',
    pathMatch: 'full',
    component: ProductChartAtGlanceComponent,
  },
  {
    path: 'report-generation',
    pathMatch: 'full',
    component: ProductReportGenerationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductDetailsRoutingModule {}
